module.exports = __webpack_public_path__ + "img/settings_filled_32.b3f25d50.svg";